import type { RoleConfig } from '../types.js';

export const framer: RoleConfig = {
  id: 'framer',
  faction: 'mafia',
  title: { ru: 'Подставщик', uk: 'Підставник' },
  latin: 'FRAMER',
  number: '22',
  accent: '#7a3a8a',
  ability: {
    ru: 'Ночью «подставляет» игрока — Шериф увидит его как мафию.',
    uk: 'Вночі «підставляє» гравця — Шериф побачить його як мафію.',
  },
  abilities: [
    { key: 'frame', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
};
